import React, { FunctionComponent, Fragment } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { formattedPriceRangeEDP } from 'src/lib/formatter'
import { EVENT_STATES } from 'src/constants/constants'
import locale from '../locale'

const style = require('./Price.css')

interface Props {
  minPrice: number,
  maxPrice: number,
  currency: string,
  listingStatus: string,
}


const PriceComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  minPrice,
  maxPrice,
  currency,
  listingStatus,
  intl,
}) => {
  const priceRange = formattedPriceRangeEDP({ minPrice, maxPrice, currency, intl })

  const determinePriceDisplay = () => (priceRange.length === 1 ?
    <div className={style.priceRange}>{priceRange[0]}</div> :
    <Fragment>
      <div className={style.priceRange}>{priceRange[0]}</div>
      <div className={style.priceRange}>- {priceRange[1]}</div>
    </Fragment>)

  const priceDisplay = () => {
    switch (listingStatus) {
      case EVENT_STATES.noData:
        return null
      case EVENT_STATES.soldOutWaitlistEnabled:
      case EVENT_STATES.soldOutWaitlistNotEnabled:
        return <div>{intl.formatMessage(locale.eventSoldOut)}</div>
      case EVENT_STATES.fanReminderWaitlistEnabled:
      case EVENT_STATES.fanReminderWaitlistEnabledWithLockedTickets:
      case EVENT_STATES.semiAvailableNotStarted:
      case EVENT_STATES.semiAvailableAllLocked:
        return null
      case EVENT_STATES.salesEnded:
      case EVENT_STATES.salesEndedEventOver:
        return <div>{intl.formatMessage(locale.eventEnded)}</div>
      case EVENT_STATES.unavailableAllHidden:
      case EVENT_STATES.unavailableOnlyAtDoor:
        return <div>{intl.formatMessage(locale.eventUnavailable)}</div>
      case EVENT_STATES.unavailableGeofenced:
        return <div>{intl.formatMessage(locale.eventUnavailableGeofenced)}</div>
      case EVENT_STATES.availableStandard:
        return determinePriceDisplay()
      case 'unavailableHiddenNoWaitlist':
        return <div>{intl.formatMessage(locale.eventUnavailable)}</div>
      default:
        return null
    }
  }

  const price = priceDisplay()
  const getPriceClass = (minPrice: number) => `${style.container} ${(minPrice === 0) ? style.free : ''} ${listingStatus !== 'availableStandard' ? style.notAvailable : ''}`

  return (
    price && <div className={getPriceClass(minPrice)}>
      {price}
    </div>
  )
}

export const Price = injectIntl(PriceComponent)
